import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  LomavisBarChart2,
  BarChartData
} from '@/lomavisSharedUi/atoms/charts/LomavisBarChart2/LomavisBarChart2';
import {
  LomavisMapWithHighlights1,
  ILomavisMapWithHighlights1Data
} from '@/lomavisSharedUi/atoms/charts/LomavisMapWithHighlights1/LomavisMapWithHighlights1';
import { LomavisCard1 } from '@/lomavisSharedUi/atoms/cards/LomavisCard1/LomavisCard1';
import { LomavisDataProcessingPlaceholder } from '@/lomavisSharedUi/atoms/placeholders/LomavisDataProcessingPlaceholder';
import { LomavisPlatformIconList1 } from '@/lomavisSharedUi/molecules/icons/LomavisPlatformIconList1/LomavisPlatformIconList1';
import { PLATFORM_LIST_WITH_ALL } from '@/config/constants';

interface LomavisDemographicsFollowerCitiesProps {
  /** The text to display inside the H1 heading */
  title: string;
  /** Data for the bar chart */
  barChartData?: BarChartData[];
  /** Data for the map */
  mapData?: ILomavisMapWithHighlights1Data[];
  /** Option if the download button should be shown */
  showDownloadButton?: boolean;
  /** Optional to show the view more button */
  showViewMoreButton?: boolean;
  /** URL for the view more button */
  viewMoreButtonUrl?: string;
  /** Optional list of platforms to display in the card header */
  platforms?: Array<(typeof PLATFORM_LIST_WITH_ALL)[number]>;
}

/**
 * Organisms: LomavisDemographicsFollowerCities
 * A component that displays a list of entries on the left side and a map on the right side
 */
export const LomavisDemographicsFollowerCities: React.FC<
  LomavisDemographicsFollowerCitiesProps
> = ({ title, barChartData = [], mapData = [], showDownloadButton=true, showViewMoreButton=false, viewMoreButtonUrl='#', platforms }) => {
  const isDataAvailable = barChartData.length > 0 || mapData.length > 0;
  
  // Create subtitle with platform icons if platforms are provided
  const subtitle = platforms && platforms.length > 0 ? <LomavisPlatformIconList1 platforms={platforms} /> : undefined;

  return (
    <LomavisCard1 
      title={title} 
      subtitle={subtitle}
      className="h-100" 
      showDownloadButton={showDownloadButton} 
      showLinkButton={showViewMoreButton} 
      linkButtonUrl={viewMoreButtonUrl}>
      {isDataAvailable ? (
        <Row className="h-100" style={{ minHeight: '420px' }}>
          {/* Left side: List of entries */}
          <Col md={5} className="h-100">
            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
              <LomavisBarChart2
                title={''}
                centerVertically={false}
                data={barChartData}
                showPercentage={true}
                sortAscending={false}
              />
            </div>
          </Col>

          {/* Right side: Map */}
          <Col md={7} className="h-100">
            <div className="h-100 position-relative">
              <LomavisMapWithHighlights1 title={''} data={mapData} />
            </div>
          </Col>
        </Row>
      ) : (
        <LomavisDataProcessingPlaceholder />
      )}
    </LomavisCard1>
  );
};
